import React from 'react';
import Typography from '@material-ui/core/Typography';
import { getURLPrefix } from '../../services/utilities';

const InvalidLink = () => {
  // TODO: needs actual design. Just a placeholder now.
  return (
    <div>
      <Typography>This link is invalid.</Typography>
      <Typography>
        <a href={`${getURLPrefix()}/`}>Click here to go Home</a>
      </Typography>
    </div>
  );
};

export default InvalidLink;
